module.exports = __webpack_public_path__ + "3ae50b14bceda96cdd3214b3f50023ce.svg";